/* eslint-disable max-len */
import React, { useState, useEffect } from "react";
import { object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import NotificationStories from "../../rows/NotificationStories";

import { staticTexts } from "../../utils/Translate";
import { useAutoRefresh } from "../../utils/react-utils";

import "./notification.m.css";

function NotificationPageBase({ data, lang, pageType }) {
  const { stories } = data;
  const [notifications, setNotifications] = useState([]);

  if (!stories.length) {
    return <div styleName="not-found-wrapper">no stories found !!</div>;
  }

  useEffect(() => {
    const limit = 8;
    const offset = 0;

    fetch(`/feapi/push-engage-notifications?limit=${limit}&offset=${offset}`)
      .then((res) => res.json())
      .then((resp) => {
        setNotifications(resp.notifications);
      });
  }, []);

  useAutoRefresh();

  return (
    <React.Fragment>
      <div>
        <div styleName="content">
          <h1 styleName="notification-title">{staticTexts(lang).notifications}</h1>
        </div>

        <div>{notifications && <NotificationStories stories={notifications} />}</div>
      </div>
    </React.Fragment>
  );
}

NotificationPageBase.propTypes = {
  data: object,
  lang: string,
  pageType: string,
};

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
  pageType: get(state, ["qt", "pageType"], ""),
});

export const NotificationPage = connect(mapStateToProps, null)(NotificationPageBase);
